import { APIQueryResult, useAPIQuery } from 'shared/api/APIQuery';
import { requestCarrierAPI } from 'shared/api/CarrierAPIClient';
import {
  VerifiedCarrierApplicationStatusDTO,
  verifiedCarrierApplicationStatusSchema,
} from './VerifiedCarrierApplicationStatusDTO';

export function useVerifiedCarrierApplicationStatus(): APIQueryResult<VerifiedCarrierApplicationStatusDTO> {
  return useAPIQuery(
    ['verified-carrier-application', 'status'],
    () =>
      requestCarrierAPI(
        'GET /internal/web/carrier/verified-carrier-application/status/',
      ),
    { schema: verifiedCarrierApplicationStatusSchema },
  );
}
